import TrayectoriaLaboralApiRepository from '@modules/referencias-laborales/infrastructure/TrayectoriaLaboralApiRepository'

const repository = new TrayectoriaLaboralApiRepository()

export default {
  namespaced: true,
  state: () => ({
    trayectorias: [],
    trayectoria: null,
    loading: false,
    error: null,
  }),
  getters: {
    getTrayectorias(state) {
      return state.trayectorias
    },
    getTrayectoria(state) {
      return state.trayectoria
    },
    isLoading(state) {
      return state.loading
    },
    getError(state) {
      return state.error
    },
  },
  mutations: {
    SET_TRAYECTORIAS(state, trayectorias) {
      state.trayectorias = trayectorias
    },
    SET_TRAYECTORIA(state, trayectoria) {
      state.trayectoria = trayectoria
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await repository.getAllTrayectoriaLaboralRegistrada()
        commit('SET_TRAYECTORIAS', data)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchByPersonal({ commit }, idPersonal) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await repository.getTrayectoriaLaboral(idPersonal)

        const trayectoriasFiltradas = Array.isArray(data) ? data.filter((t) => t.fk_idPersonal === idPersonal) : []
        commit('SET_TRAYECTORIAS', trayectoriasFiltradas)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchById({ commit }, { idPersonal, idTrayectoriaLaboral }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await repository.getTrayectoriaLaboralById(idPersonal, idTrayectoriaLaboral)
        commit('SET_TRAYECTORIA', data)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchEspecifica({ commit }, idTrayectoriaLaboral) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const data = await repository.getTrayectoriaLaboralEspecifica(idTrayectoriaLaboral)
        commit('SET_TRAYECTORIA', data)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async create({ dispatch, commit }, payload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        await repository.createTrayectoriaLaboral(payload)
        dispatch('fetchByPersonal', payload.fk_idPersonal)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async update({ dispatch, commit }, { idTrayectoriaLaboral, payload }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        await repository.updateTrayectoriaLaboralEspecifica(idTrayectoriaLaboral, payload)
        dispatch('fetchByPersonal', payload.fk_idPersonal)
      } catch (error) {
        commit('SET_ERROR', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}
